import { render, staticRenderFns } from "./mobileIndex.vue?vue&type=template&id=22b26dac&scoped=true&"
import script from "./mobileIndex.vue?vue&type=script&lang=js&"
export * from "./mobileIndex.vue?vue&type=script&lang=js&"
import style1 from "./mobileIndex.vue?vue&type=style&index=1&id=22b26dac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b26dac",
  null
  
)

export default component.exports